module.exports = __webpack_public_path__ + "media/images/linkedin-4356bdead2aab584279581b6b3af9923.svg";